import React from 'react';
import Column from '@amzn/meridian/column';
import Card from '@amzn/meridian/card';
import Text from '@amzn/meridian/text';
import BrandMark from './BrandMark';

interface AuthCardProps {
    title: string;
    subtitle?: string;
    children: React.ReactNode;
}

/**
 * Centers an authentication card (sign in / register / confirm) in the page
 * with a consistent width, the SPIE logo, and a heading.
 */
export default function AuthCard({ title, subtitle, children }: AuthCardProps) {
    return (
        <Column alignmentHorizontal="center" spacingInset="600" width="100%">
            <div style={{ width: '100%', maxWidth: 420 }}>
                <Card spacingInset="500">
                    <Column spacing="400">
                        <Column alignmentHorizontal="center" spacing="300">
                            <BrandMark height={56} />
                        </Column>
                        <Column spacing="100">
                            <Text type="h400">{title}</Text>
                            {subtitle ? (
                                <Text type="b200" color="secondary">
                                    {subtitle}
                                </Text>
                            ) : null}
                        </Column>
                        {children}
                    </Column>
                </Card>
            </div>
        </Column>
    );
}

AuthCard.defaultProps = {
    subtitle: undefined,
};
